'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var Vue = _interopDefault(require('vue'));
var detectWebp = require('@mx/util/detect-webp');

var nodes = [];
var location, winHeight, checking, config;
function install(Vue$$1, options) {
  Vue$$1.directive('lazy', {
    bind: add,
    unbind: remove,
    update: update
  });
  winHeight = window.innerHeight;
  config = _objectSpread({
    offset: 0
  }, options);

  if (config.webp) {
    detectWebp.detectWebp(function (result) {
      handler(true);
      config.webp = result && config.webp;
    });
  } else {
    handler(true);
  }
}

function add(node) {
  nodes.push(node);
  onScroll();
}

function update(node) {
  updateLocation();
  setSrc(node);
}

function remove(node) {
  nodes.splice(nodes.indexOf(node), 1);
}

function handler(action) {
  window[action ? 'addEventListener' : 'removeEventListener']('scroll', onScroll);
}

function onScroll() {
  if (nodes.length && !checking) {
    checking = true;
    Vue.nextTick(check);
  }
}

function check() {
  updateLocation();
  nodes.map(function (node) {
    visible(node) && setSrc(node);
  });
  checking = false;
}

function updateLocation() {
  location = window.scrollY;
}

function visible(node) {
  var rect = node.getBoundingClientRect();

  if (rect.width && rect.height) {
    var viewBot = location + winHeight;
    var nodeTop = rect.top + location;
    var nodeBot = nodeTop + node.offsetHeight;
    return nodeBot >= location - config.offset && nodeTop <= viewBot + config.offset;
  }

  return false;
}

function setSrc(node) {
  var attr = config.webp ? 'data-webp' : 'data-src';
  var url = node.getAttribute(attr);

  if (url) {
    var img = new Image();
    img.src = url;

    img.onload = function () {
      node.setAttribute('src', url);
      remove(node);

      if (config.fade) {
        node.classList.add('fade-in');
        node.addEventListener('webkitAnimationEnd', onAnimationEnd);
        node.addEventListener('animationend', onAnimationEnd);
      }
    };

    node.removeAttribute(attr);
  }
}

function onAnimationEnd() {
  this.classList.remove('fade-in');
  this.removeEventListener('webkitAnimationEnd', onAnimationEnd);
  this.removeEventListener('animationend', onAnimationEnd);
}

exports.default = install;
